import { render, staticRenderFns } from "./NavItemsContainer.vue?vue&type=template&id=2adacf90&"
import script from "./NavItemsContainer.vue?vue&type=script&lang=js&"
export * from "./NavItemsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports